<template>
  <section class="signature-section" :style="{ backgroundImage: activityData.images.bg ? `url(${activityData.images.bg})` : 'none' }">
    <Header />
    <div id="pdfContainer" class="signature-container">
      <iframe class="signature-pdf-iframe" :src="pdfSrc" frameborder="0"></iframe>
      <!-- <img :src="sigImage" v-if="sigImage"> -->
      <br />
      <button class="button" style="background: #eee; color: black" @click.prevent="showCanvasDraw = true" v-if="!showCanvasDraw">
        <i class="fas fa-signature"></i>
        Assinar
      </button>
      <!-- <button @click.prevent="exportPDF" v-if="!showCanvasDraw">Exportar</button> -->
    </div>

    <CanvasDraw :userName.sync="userName" @close="closeSig" @submit="submit" v-if="showCanvasDraw" />

    <Footer style="position: fixed" />
    <Spinner style="z-index: 10; padding-top: 30vh" :showSpinner="showSpinner" />
    <div class="signature-success-popup" v-if="showSuccessPopup">
      <transition appear name="popup-from-bottom" mode="in-out">
        <div class="signature-success">
          <i class="fas fa-check"></i>
          <p style="margin-left: 10px; font-size: 1.4rem">{{ activityData.property.signatureSentSuccessText ? activityData.property.signatureSentSuccessText : 'Obrigado pela assinatura!' }}</p>
        </div>
      </transition>
    </div>
  </section>
</template>
<script>
import api from '@/services/api';
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import Spinner from '@/components/ui/Spinner.vue';
import CanvasDraw from '@/components/general/CanvasDraw.vue';
import { jsPDF } from 'jspdf';

export default {
  name: 'Signature',

  components: { Header, Footer, Spinner, CanvasDraw },

  data() {
    return {
      activityData: { images: {} },
      showSpinner: false,
      showCanvasDraw: false,
      sigImage: null,
      pdfSrc: '',
      userName: '',
      showSuccessPopup: false,
    };
  },
  methods: {
    loadActivity() {
      api.get(`activity/${this.$route.params.stream}`).then((response) => {
        this.activityData = { ...this.activityData, ...response.data };
        this.activityData.images = JSON.parse(this.activityData.images);
        this.activityData.property = JSON.parse(this.activityData.property);
        this.pdfSrc = this.activityData.property.src;
        // console.log('PROPERTY: ' + this.activityData.property);
      });
    },
    sigReady(e) {
      this.sigImage = e;
      this.showCanvasDraw = false;
    },
    closeSig() {
      this.showCanvasDraw = false;
    },
    exportPDF() {
      this.showCanvasDraw = true;

      const doc = new jsPDF();
      doc.html();
      doc.html(document.getElementById('pdfContainer'), {
        callback: (doc) => {
          doc.save('a4.pdf');
          this.showCanvasDraw = false;
        },
      });
    },
    uploadImage(uri) {
      // console.log('ON UPLOAD', this.userName, { uri });
      this.showSpinner = true;
      let byteString = atob(uri.split(',')[1]);
      let ab = new ArrayBuffer(byteString.length);
      let ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      let blob = new Blob([ia], {
        type: 'image/png',
      });
      let file = new File([blob], `${this.userName}_sig.png`);
      const formData = new FormData();
      formData.append('file', file);
      api
        .post(`activity/${this.$route.params.stream}/materialUpload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            this.showSpinner = true;
            if (progressEvent.loaded === progressEvent.total) {
              this.showSpinner = false;
            }
          },
        })
        .then((response) => {
          // console.log('uploadImage Response', { response });
          if (response.data) {
            this.showCanvasDraw = false;
            // alert('Assinatura enviada com sucesso');
            this.showSuccessPopup = true;
            setTimeout((_) => {
              this.showSuccessPopup = false;
            }, 3000);
          }
        })
        .catch((err) => console.error(err));
    },
    submit(uri) {
      if (!this.userName) this.userName = 'Anom';
      this.uploadImage(uri);
    },
  },
  beforeMount() {
    this.userName = this.$store.state.user.name;
    this.loadActivity();
  },
};
</script>

<style lang="scss">
.signature-section {
  position: relative;
  min-height: 100dvh;
  background-color: var(--main-color);
}
.signature-pdf-iframe {
  position: relative;
  width: 100%;
  min-height: 58vh;
  // display: none;
}
.signature-container {
  position: relative;
  color: black;
  // background: beige;
  // height: 90vh;
  max-width: 900px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  margin-top: 99px;
  margin-left: auto;
  margin-right: auto;

  @include media('<=phone') {
    margin-top: 50px;
  }
  @media (max-height: 460px) {
    margin-top: 50px;
  }
}
.signature-success-popup {
  pointer-events: none;

  position: fixed;
  bottom: 0;
  width: 100vw;
  height: 100dvh;
  // background: #0ad;
  z-index: 100;

  display: flex;
  justify-content: center;
  align-items: flex-end;

  .signature-success {
    pointer-events: auto;

    position: relative;
    flex-grow: 1;
    height: 100%;
    max-height: 300px;
    max-width: 480px;
    color: var(--text-color);
    background: var(--secondary-color);

    display: flex;
    align-items: center;
    justify-content: center;
    // transition: all 1s ease-in;
  }

  .popup-from-bottom-enter-active,
  .popup-from-bottom-leave-active {
    animation: popup-from-bottom 0.5s ease-in;
  }
  @keyframes popup-from-bottom {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0%);
    }
  }
}
</style>
